import styled from 'styled-components';
import { colors } from '@styles';
import { flexMixin, textMixin } from '@styles/mixins';

export const HeaderReservationPageWrap = styled.div`
    ${flexMixin('row', 'space-between', 'center')}
    flex-wrap: wrap;
    gap: 10px;
`;

export const CardInfo = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 19%;
    min-width: 190px;
    flex: 1;
`;

export const CardTextArea = styled.div`
    width: 100%;
    height: 92px;
    ${flexMixin('column', 'center', 'flex-start')}
    background: ${colors.cleanWhite};
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.11);
    border-radius: 5px;
    padding-left: 16px;
    flex: none;
    order: 0;
    flex-grow: 0;
`;

export const SelectCardTextArea = styled(CardTextArea)`
    padding-left: 0;
`;

export const CardTitle = styled.div`
    ${textMixin({
        fontSize: '30px',
        fontWeight: 600,
    })};
    line-height: 34px;
    align-items: center;
    color: ${colors.grey};
`;

export const CardText = styled.div`
    width: 132px;
    height: 28px;
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    line-height: 28px;
    align-items: center;
    color: #8f8f8f;
`;
export const CardTexSelect = styled(CardText)`
    padding-left: 20px;
    width: 100%;
`;
